import PgxHeader from "./PgxHeader";
import GenesForSelecting from "../patientInit/pgx/GenesForSelecting";
import React from "react";
import {useTranslation} from "react-i18next";

const CreateNewGeneView = ({ newPgx, setNewPgx, init = false, availableGeneNames, setAvailableGeneNames,
                             onHandleInitNewTest, onHandleNextClick, onHandleCancel}) => {
  const {t} = useTranslation();
  const nextDisabled = !(newPgx?.labName && newPgx?.testDate && newPgx?.genes?.length > 0);

  return (
    <>
      <PgxHeader newPgx={ newPgx } setNewPgx={ setNewPgx } init={ init } createNewDialogOpened={ true }/>
      <GenesForSelecting patGenes={ newPgx?.genes } onHandleInitNewTest={ onHandleInitNewTest }
                         availableGeneNames={ availableGeneNames }
                         setAvailableGeneNames={ setAvailableGeneNames }/>
      <div className="w3-row w3-right w3-margin-bottom">
        <button className="w3-btn w3-round-xlarge w3-theme-d5 w3-margin-right" onClick={ onHandleNextClick }
                disabled={ nextDisabled }>
          { t("next") }
        </button>
        <button className="w3-btn w3-round-xlarge w3-theme-d5" onClick={ onHandleCancel }>{ t("cancel") }</button>
      </div>
    </>
  )
}

export default CreateNewGeneView;